import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectBoxServiceService } from '../service/select-box-service.service';
import { AppPlatformService } from 'src/app/service/platform/app-platform.service';
@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss'],
})
export class SelectBoxComponent implements OnInit {

  @Input() value: string;
  @Input() addCustomClass: string;
  @Input() addBackground: string;
  @Input() optionsContainerHeight: string;
  @Input() paddingX: string;
  @Input() paddingY: string;
  expandir_contraer: boolean = false
  @Input() addFilterIcon: boolean = false;
  @Input() addAlertIcon: boolean = false;
  @Output() selectClick: EventEmitter<any> = new EventEmitter<any>();

  isIOS: boolean = false;
  isWebKitBug: boolean = false;

  constructor(
    private service: SelectBoxServiceService,
    private appPlatformService: AppPlatformService
  ) { }

  get containerClasses(): string {
    if (!this.expandir_contraer) return '';
    if (this.optionsContainerHeight) return this.optionsContainerHeight;

    const base = 'max-h-[9.5rem] sm:max-h-40 lg:max-h-50';
    // WebKit (Safari de escritorio o cualquier navegador en iOS, ya que todos usan WebKit)
    // no anima/aplica bien max-height solo; necesita un height explícito.
    return (this.isIOS || this.isWebKitBug) ? `${base} min-h-full h-[9rem]` : base;
  }


  ngOnInit() {
    this.service.open_and_close.subscribe(res => this.expandir_contraer = res);
    this.isIOS = this.appPlatformService.isIosHibridApp();
    this.isWebKitBug = this.detectIOSDeviceOrSafari();
  }

  private detectIOSDeviceOrSafari(): boolean {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent;

    // Cualquier navegador en iOS/iPadOS corre sobre WebKit (Chrome, Firefox, etc. incluidos).
    const isIOSDevice = /iPad|iPhone|iPod/.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS 13+ se reporta como Mac

    // Safari de escritorio (macOS) también usa WebKit.
    const isDesktopSafari = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(ua);

    return isIOSDevice || isDesktopSafari;
  }

  abrirCerrar() {
    this.expandir_contraer = !this.expandir_contraer;
    this.selectClick.emit(this.expandir_contraer);
  }

  handleClickedOutside(){
    this.expandir_contraer = false;
    // this.selectClick.emit(this.expandir_contraer);
  }


}
